import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Formik } from 'formik';
import { forwardRef } from 'react';
const FormikForm = forwardRef((props, ref) => {
    const { onSubmit = () => null, initialValues = {}, validationSchema = null, children, } = props;
    return (_jsx(Formik, { innerRef: ref, initialValues: initialValues, onSubmit: onSubmit, validationSchema: validationSchema, children: _jsx(_Fragment, { children: children }) }));
});
export default FormikForm;
